import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProductCategoryEnum } from '@mwe/constants';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { containsProductCategory, isProductCategoryFernwaerme } from '@mwe/utils';

@Component({
  selector: 'mwe-new-bank-account-info-texts',
  templateUrl: './new-bank-account-info-texts.component.html',
  imports: [InfoboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewBankAccountInfoTextsComponent {
  // todo remove me once every parent has same design
  readonly useTemplate = input<'alert' | 'info-box'>('alert');
  readonly hasSpotTariff = input<boolean>(false);
  readonly productCategories = input<string[]>([]);

  readonly isStromInfoVisible = computed<boolean>(() => this.rawIsStrom() && !this.hasSpotTariff());
  readonly isStromGasInfoVisible = computed<boolean>(() => this.isStromInfoVisible() && this.isGasInfoVisible());
  private readonly rawIsStrom = computed<boolean>(() =>
    this.productCategories().some(category =>
      containsProductCategory(category, [ProductCategoryEnum.STROM, ProductCategoryEnum.NACHTSTROM]),
    ),
  );
  readonly isFernwaermeInfoVisible = computed<boolean>(() =>
    this.productCategories().some(category => isProductCategoryFernwaerme(category)),
  );
  readonly isGasInfoVisible = computed<boolean>(() =>
    this.productCategories().some(category => containsProductCategory(category, [ProductCategoryEnum.GAS])),
  );

  readonly messageKey = computed<string[]>(() => {
    const messageKey = [];

    if (this.isStromInfoVisible() || this.isGasInfoVisible()) messageKey.push('invoiceData.change.newBankData.info');
    if (this.isGasInfoVisible()) messageKey.push('invoiceData.change.newBankData.infoStromGas');
    if (this.isStromInfoVisible() && !this.isGasInfoVisible()) messageKey.push('invoiceData.change.newBankData.infoStrom');
    if (this.isFernwaermeInfoVisible()) messageKey.push('invoiceData.change.newBankData.infoFernwaerme');

    return messageKey;
  });
  readonly messageKeys = computed<string[]>(() => {
    const messageKeys = ['invoiceData.change.newBankData.info'];

    if (this.isStromGasInfoVisible()) messageKeys.push('invoiceData.change.newBankData.infoStromGas');
    if (this.isFernwaermeInfoVisible()) messageKeys.push('invoiceData.change.newBankData.infoFernwaerme');

    return messageKeys;
  });
}
